function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var DEFAULT_TITLES = {
  1: 'no display text for level 1',
  2: 'no display text for level 2',
  3: 'no display text for level 3'
};

/**
 * Parses navigation data and returns title and URL with fallbacks
 */
var parseNavigationData = function parseNavigationData(displayText, navigationLink, level) {
  var _navigationLink$, _navigationLink$2;
  var title = displayText || (navigationLink === null || navigationLink === void 0 || (_navigationLink$ = navigationLink[0]) === null || _navigationLink$ === void 0 ? void 0 : _navigationLink$.title) || DEFAULT_TITLES[level];
  var url = (navigationLink === null || navigationLink === void 0 || (_navigationLink$2 = navigationLink[0]) === null || _navigationLink$2 === void 0 ? void 0 : _navigationLink$2.url) || '';
  return {
    title,
    url
  };
};
var createNavItem = function createNavItem(title, url, items, level) {
  return _objectSpread({
    title,
    url,
    items,
    level
  }, url && {
    role: 'regular_link'
  });
};
var addParentLinkToChildren = function addParentLinkToChildren(item, childLevel) {
  if (item.url && item.items && item.items.length > 0) {
    return [].concat(_toConsumableArray(item.items), [{
      title: "See all ".concat(item.title),
      url: item.url,
      items: [],
      level: childLevel,
      role: 'see_all_link'
    }]);
  }
  return item.items || [];
};
export var transformToDrilldownProp = function transformToDrilldownProp(content) {
  var navigation = {
    title: 'Shop by department',
    items: _toConsumableArray(content.l1_navigation.map(function (l1) {
      var _parseNavigationData = parseNavigationData(l1.l1_display_text, l1.l1_navigation_link, 1),
        l1Title = _parseNavigationData.title,
        l1Url = _parseNavigationData.url;
      var l2Items = l1.l2_navigation.map(function (l2) {
        var _parseNavigationData2 = parseNavigationData(l2.l2_display_text, l2.l2_navigation_link, 2),
          l2Title = _parseNavigationData2.title,
          l2Url = _parseNavigationData2.url;
        var l3Items = l2.l3_navigation.map(function (l3) {
          var _parseNavigationData3 = parseNavigationData(l3.l3_display_text, l3.l3_navigation_link, 3),
            l3Title = _parseNavigationData3.title,
            l3Url = _parseNavigationData3.url;
          return createNavItem(l3Title, l3Url, [], 3);
        });
        var l2Item = createNavItem(l2Title, l2Url, l3Items, 2);
        var l3ItemsWithSeeAll = addParentLinkToChildren(l2Item, 3);
        return _objectSpread(_objectSpread({}, l2Item), {}, {
          items: l3ItemsWithSeeAll
        });
      });
      var l1Item = createNavItem(l1Title, l1Url, l2Items, 1);
      var l2ItemsWithSeeAll = addParentLinkToChildren(l1Item, 2);
      return _objectSpread(_objectSpread({}, l1Item), {}, {
        items: l2ItemsWithSeeAll
      });
    })),
    level: 0
  };
  return navigation;
};